import { render, staticRenderFns } from "./SwitchToSQAComponent.vue?vue&type=template&id=529de461&scoped=true"
import script from "./SwitchToSQAComponent.vue?vue&type=script&lang=js"
export * from "./SwitchToSQAComponent.vue?vue&type=script&lang=js"
import style0 from "./SwitchToSQAComponent.vue?vue&type=style&index=0&id=529de461&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529de461",
  null
  
)

export default component.exports